"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var money_1 = require("../money");
var StarRating = /** @class */ (function (_super) {
    tslib_1.__extends(StarRating, _super);
    function StarRating() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StarRating.prototype.getRatingWidth = function () {
        return {
            style: {
                width: this.props.rating * 100 + "%",
            },
        };
    };
    StarRating.prototype.render = function () {
        money_1.setConfig({ precision: 0 });
        var classes = classNames('star-rating', { 'star-rating--large': this.props.largeStars });
        return (React.createElement("div", { className: classes },
            React.createElement("div", { className: "star-rating__stars" },
                React.createElement("div", tslib_1.__assign({ className: "star-rating__stars__filled" }, this.getRatingWidth()))),
            this.props.count !== undefined &&
                React.createElement("div", { className: "star-rating__count" }, money_1.formatNumber(this.props.count))));
    };
    return StarRating;
}(React.Component));
exports.default = StarRating;
//# sourceMappingURL=star_rating.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/star_rating.js
// module id = tObM
// module chunks = 20 21